import { render, staticRenderFns } from "./Empleados.view.vue?vue&type=template&id=e2acdaa8"
import script from "./Empleados.view.vue?vue&type=script&lang=js"
export * from "./Empleados.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports